import { css } from '@emotion/core';
import { IThemeVariables } from './themeVariables';

const structMargin = (themeVariables: IThemeVariables) => ({
  auto: {
    all: css`
      margin: auto;
    `,
    horizontal: css`
      margin: 0 auto;
    `,
    vertical: css`
      margin: auto 0;
    `
  },
  none: {
    all: css`
      margin: 0;
    `,
    bottom: css`
      margin-bottom: 0;
    `,
    left: css`
      margin-left: 0;
    `,
    right: css`
      margin-right: 0;
    `,
    top: css`
      margin-top: 0;
    `
  },
  space: {
    all: [
      css`
        margin: ${themeVariables.layout.spacing[0]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[1]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[2]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[3]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[4]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[5]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[6]};
      `,
      css`
        margin: ${themeVariables.layout.spacing[7]};
      `
    ],
    bottom: [
      css`
        margin-bottom: ${themeVariables.layout.spacing[0]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[1]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[2]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[3]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[4]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[5]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[6]};
      `,
      css`
        margin-bottom: ${themeVariables.layout.spacing[7]};
      `
    ],
    left: [
      css`
        margin-left: ${themeVariables.layout.spacing[0]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[1]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[2]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[3]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[4]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[5]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[6]};
      `,
      css`
        margin-left: ${themeVariables.layout.spacing[7]};
      `
    ],
    right: [
      css`
        margin-right: ${themeVariables.layout.spacing[0]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[1]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[2]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[3]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[4]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[5]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[6]};
      `,
      css`
        margin-right: ${themeVariables.layout.spacing[7]};
      `
    ],
    top: [
      css`
        margin-top: ${themeVariables.layout.spacing[0]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[1]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[2]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[3]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[4]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[5]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[6]};
      `,
      css`
        margin-top: ${themeVariables.layout.spacing[7]};
      `
    ]
  }
});

const structPadding = (themeVariables: IThemeVariables) => ({
  auto: {
    all: css`
      padding: auto;
    `,
    horizontal: css`
      padding: 0 auto;
    `,
    vertical: css`
      padding: auto 0;
    `
  },
  none: {
    all: css`
      padding: 0;
    `,
    bottom: css`
      padding-bottom: 0;
    `,
    left: css`
      padding-left: 0;
    `,
    right: css`
      padding-right: 0;
    `,
    top: css`
      padding-top: 0;
    `
  },
  space: {
    all: [
      css`
        padding: ${themeVariables.layout.spacing[0]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[1]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[2]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[3]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[4]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[5]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[6]};
      `,
      css`
        padding: ${themeVariables.layout.spacing[7]};
      `
    ],
    bottom: [
      css`
        padding-bottom: ${themeVariables.layout.spacing[0]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[1]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[2]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[3]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[4]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[5]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[6]};
      `,
      css`
        padding-bottom: ${themeVariables.layout.spacing[7]};
      `
    ],
    left: [
      css`
        padding-left: ${themeVariables.layout.spacing[0]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[1]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[2]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[3]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[4]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[5]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[6]};
      `,
      css`
        padding-left: ${themeVariables.layout.spacing[7]};
      `
    ],
    right: [
      css`
        padding-right: ${themeVariables.layout.spacing[0]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[1]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[2]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[3]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[4]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[5]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[6]};
      `,
      css`
        padding-right: ${themeVariables.layout.spacing[7]};
      `
    ],
    top: [
      css`
        padding-top: ${themeVariables.layout.spacing[0]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[1]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[2]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[3]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[4]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[5]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[6]};
      `,
      css`
        padding-top: ${themeVariables.layout.spacing[7]};
      `
    ]
  }
});

const basic = (alignment: string, modifier: string) => ({
  normal: css`
    ${`${alignment}-${modifier}`}: normal;
  `,
  stretch: css`
    ${`${alignment}-${modifier}`}: stretch;
  `
});

const positional = (alignment: string, modifier: string) => ({
  // tslint:disable
  center: css`
    ${`${alignment}-${modifier}`}: center;
  ` /* Pack items around the center */,
  end: css`
    ${`${alignment}-${modifier}`}: end;
  ` /* Pack items from the end */,
  flexEnd: css`
    ${`${alignment}-${modifier}`}: flex-end;
  ` /* Pack flex items from the end */,
  flexStart: css`
    ${`${alignment}-${modifier}`}: flex-start;
  ` /* Pack flex items from the start */,
  selfEnd: css`
    ${`${alignment}-${modifier}`}: self-end;
  `,
  selfStart: css`
    ${`${alignment}-${modifier}`}: self-start;
  `,
  start: css`
    ${`${alignment}-${modifier}`}: start;
  ` /* Pack items from the start */
});

const baseline = (alignment: string, modifier: string) => ({
  baseline: css`
    ${`${alignment}-${modifier}`}: baseline;
  `,
  firstBaseline: css`
    ${`${alignment}-${modifier}`}: first baseline;
  `,
  lastBaseline: css`
    ${`${alignment}-${modifier}`}: last baseline;
  ` /* Overflow alignment (for positional alignment only) */,
  safeCenter: css`
    ${`${alignment}-${modifier}`}: safe center;
  `,
  unsafeCenter: css`
    ${`${alignment}-${modifier}`}: unsafe center;
  `
});

const global = (alignment: string, modifier: string) => ({
  inherit: css`
    ${`${alignment}-${modifier}`}: inherit;
  `,
  initial: css`
    ${`${alignment}-${modifier}`}: initial;
  `,
  unset: css`
    ${`${alignment}-${modifier}`}: unset;
  `
});

const flexbox = {
  align: {
    content: {
      /* Basic keywords */
      ...basic('align', 'content'),

      /* Positional alignment */
      /* align-content does not take left and right values */
      ...positional('align', 'content'),

      /* Baseline alignment */
      ...baseline('align', 'content'),

      /* Global values */
      ...global('align', 'content')
    },

    items: {
      /* Basic keywords */
      ...basic('align', 'items'),

      /* Positional alignment */
      /* align-items does not take left and right values */
      ...positional('align', 'items'),

      /* Baseline alignment */
      ...baseline('align', 'items'),

      /* Global values */
      ...global('align', 'items')
    },

    self: {
      /* Basic keywords */
      ...basic('align', 'self'),

      /* Positional alignment */
      /* align-items does not take left and right values */
      ...positional('align', 'self'),

      /* Baseline alignment */
      ...baseline('align', 'self'),

      /* Global values */
      ...global('align', 'self')
    }
  },

  direction: {
    column: {
      /* The direction in which lines of text are stacked */
      default: css`
        flex-direction: column;
      `,

      /* Like <column>, but reversed */
      reverse: css`
        flex-direction: column-reverse;
      `
    },
    /* Global values */
    inherit: css`
      flex-direction: inherit;
    `,
    initial: css`
      flex-direction: initial;
    `,
    row: {
      /* The direction text is laid out in a line */
      default: css`
        flex-direction: row;
      `,

      /* Like <row>, but reversed */
      reverse: css`
        flex-direction: row-reverse;
      `
    },
    unset: css`
      flex-direction: unset;
    `
  },

  justifyContent: {
    spaceBetween: css`
      justify-content: space-between;
    `,

    /* Basic keywords */
    ...basic('justify', 'content'),

    /* Positional alignment */
    /* align-content does not take left and right values */
    ...positional('justify', 'content'),

    /* Baseline alignment */
    ...baseline('justify', 'content'),

    /* Global values */
    ...global('justify', 'content')
  }
};

export interface IStructureVariables {
  flex: object;
  margin: object;
  padding: object;
}

export const getStructureVariables = (themeVariables: IThemeVariables) => ({
  flex: flexbox,
  margin: structMargin(themeVariables),
  padding: structPadding(themeVariables)
});
